var ClearLocalStorage = /** @class */ (function () {
    function ClearLocalStorage(exclude) {
        this.exclude = exclude;
    }
    ClearLocalStorage.prototype.clear = function () {
        var _this = this;
        Object.keys(localStorage)
            .filter(function (key) { return !_this.exclude.includes(key); })
            .map(function (key) { return localStorage.removeItem(key); });
    };
    return ClearLocalStorage;
}());
export default ClearLocalStorage;
